<template>

<!--
<c:if test="${ _DEVICE_TYPE eq 'APP' }">
<script>
$(function() {
	$("#footer_wrap").remove();
})
</script>
</c:if> -->

<!-- <c:if test="${ _DEVICE_TYPE  ne 'APP' }"> -->

		<!-- 푸터 시작 -->
		<div id="footer_wrap">
			<!-- 푸터 영역 시작 -->
        <div class="svc_cont">
				  <div class="container">
            <span @click="$router.push('/member/info/customerpersonal')">개인정보보호방침<em>|</em></span>
            <span @click="$router.push('/member/info/customerclause');">홈페이지 이용약관<em>|</em> </span>
            <span @click="$router.push('/member/info/customersite');">관련사이트<em>|</em></span>
            <span @click="$router.push('/member/info/customeremail');">이메일주소 무단수집거부</span>


<!--             <div class="rel_site" @click="rel_toggle();">관련사이트

              <dl class="rel_list">
                <dt onclick="goUrl('http://news.seoulbar.or.kr/', '_blank');">서울지방변호사회 회보</dt>
                <dt onclick="goUrl('http://probono.seoulbar.or.kr/', '_blank');">서울지방변호사회 프로보노지원센터</dt>
                <dt onclick="goUrl('http://hyungsalawyer.com/', '_blank');">서울지방변호사회 형사당직변호사제도</dt>
                <dt onclick="goUrl('http://shop.seoulbar.or.kr', '_blank');">서울지방변호사회 온라인기념품몰</dt>
              </dl>
            </div> -->

  				</div>
        </div>
        <div class="addr_cont">

          <div class="container ">

            <img src="/images/common/via_logo_w100.png" alt="서울지방변호사회" title="서울지방변호사회" class="logo_footer"/>
            <div class="address">
              (우) 06595 서울특별시 서초구 법원로 1길 21 (변호사회관) <br class="mobile"/>
              <br/>문의 전화
              <br/> [ 증표수정 및 기타오류 관련 ] : 02-6200-6224
              <br/> [ 면제증표 및 환불 관련 ] : 02-6200-6225
              <br/> [ 수임액 신고 관련 ] : 02-6200-6221
              <br/>Copyright(c) SEOUL BAR ASSOCIATION. All Rights Reserved.
            </div>
            <div class="foot_social">
  <!-- 						<span onclick="goUrl('#');" class="icon_twitter"></span> -->
              <span @click="goUrl('https://www.facebook.com/seoulbar','_blank');" class="icon_social face"></span>
              <span @click="goUrl('http://blog.naver.com/seoul_bar','_blank');"	class="icon_social blog"></span>
            </div>

            <div class="gotop" style="cursor: pointer; display: block;">
              <span>TOP</span>
            </div>
            <!-- //TOP  버튼 -->

          </div> <!-- //container -->
        </div>


				<!-- 모바일 버튼 시작 -->
					<!-- <div class="footer_moblie " onclick="go_desktop()">
						PC 버전으로 보기
					</div> -->
				<!-- 모바일 버튼 끝 -->


<!--
					<div class="footer_pc" onclick="go_desktop()">
						모바일 버전으로 보기
					</div>
-->
		</div> <!-- //footer_wrap -->






</template>


<script>
export default {
  mounted() {
    $(".gotop").hide();


    var speed = 100; // 스크롤속도
    $(".gotop").css("cursor", "pointer").click(function() {
        $('body, html').animate({scrollTop:0}, speed);
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.gotop').fadeIn();
        } else {
            $('.gotop').fadeOut();
        }
    });
  },
  methods : {
    rel_toggle() {
      $('.rel_list').toggle();
    },
    goUrl(url, target) {
    //	location.href = url;

      if(target == '_blank') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_self');
      }
    }

  },
}
</script>